const customQueryPageMessages = {
  TITLE: 'Claims List',
  SUBTITLE:
    'Create or edit your list by selecting the cohort button on the right',
  SUBTITLE1:
    'Unlock the power of data with the Custom Query Builder, an intuitive interface that allows you to craft and extract specific datasets from claims information. Forge detailed lists, from patient demographics to disease prevalence, and analyze the financial impact with precision.',
  QUERY_BUTTON_TEXT: 'Add Cohort',
  EDIT_QUERY_DATA: 'Edit Cohort',
  COHORT_DETAILS: {
    TITLE: 'Cohort Details',
    SUBTITLE:
      'Select the properties that you would like to apply to current data',
  },
  downloadCSVMessage: 'CSV File will get downloaded',
};

export default customQueryPageMessages;
